/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_A5Inputs */

const en_pc_alt_faq_a5 = /** @type {(inputs: Pc_Alt_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft, PDFsam Basic and Okular work on local files. Acrobat and Foxit also work locally but offer cloud features you can choose to use. PDFCraftTool/pdfcraft says it processes files inside your browser.`)
};

const zh_pc_alt_faq_a5 = /** @type {(inputs: Pc_Alt_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft、PDFsam Basic 和 Okular 都处理本地文件。Acrobat 和 Foxit 同样可以处理本地文件，但也提供可选的云功能。PDFCraftTool/pdfcraft 表示它在你的浏览器内处理文件。`)
};

/**
* | output |
* | --- |
* | "PdfCraft, PDFsam Basic and Okular work on local files. Acrobat and Foxit also work locally but offer cloud features you can choose to use. PDFCraftTool/pdfcr..." |
*
* @param {Pc_Alt_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_a5 = /** @type {((inputs?: Pc_Alt_Faq_A5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_A5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_a5(inputs)
	return zh_pc_alt_faq_a5(inputs)
});
export { pc_alt_faq_a5 as "pc.alt.faq.a5" }